import React, { useState, useMemo } from "react";
import { BaseDraggable } from "../BaseDraggable";
import { useStore } from "../../../stores/store";
import { LayersTab } from "./LayersTab";
import { LegendTab } from "./LegendTab";
import { CityZoomTab } from "./CityZoomTab";
import { DraggableKeys } from "../../../interfaces/config";

const key = DraggableKeys.LAYERS_DRAGGABLE;

export default function LayersDraggable() {
  const tabs = useMemo(
    () => [
      { label: "Layers", value: "layers", component: LayersTab },
      { label: "Legend", value: "legend", component: LegendTab },
      { label: "City Zoom", value: "cityZoom", component: CityZoomTab },
    ],
    []
  );

  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const isActive = useStore((state) => state.isActive);
  const toggleActiveItem = useStore((state) => state.toggleActiveItem);

  return (
    <BaseDraggable
      id={key}
      onClose={() => toggleActiveItem(key)}
      visible={isActive(key)}
      initialPosition={"top-left"}
      headerText="MAP LAYERS"
      className="bg-[#505050]"
    >
      <div>
        <div className="flex items-center font-normal justify-center bg-black md:bg-transparent text-white">
          <div role="tablist" className="tabs tabs-sm">
            {tabs.map((tab, i) => (
              <a
                role="tab"
                onClick={() => setSelectedTab(tab)}
                className={`tab text-white rounded-md hover:bg-[#393838] text-nowrap ${tab.value === selectedTab?.value
                  ? "tab-active bg-[#393838]"
                  : ""
                  }`}
                key={i}
              >
                {tab.label}
              </a>
            ))}
          </div>
        </div>
        {selectedTab && <selectedTab.component />}
      </div>
    </BaseDraggable>
  );
}
